import { IUserPicture, IVerifications } from '@/lib/interface.ts';
import { PhotoVerificationGroup } from '@/components/custom';

type TProps = {
	onDeletePicture: (userId: string, picture: IUserPicture) => void;
	verifications: IVerifications[];
}

const BodyPagePhotos = ({ verifications, onDeletePicture }: TProps) => (
	<div className='flex flex-col space-y-4'>
		{
			verifications
				.map(
					item => (
						<PhotoVerificationGroup
							readonly
							item={item}
							key={item._id}
							onClickDeletePictureBtn={onDeletePicture} />
					)
				)
		}
	</div>
);

export default BodyPagePhotos;
